import { Eye } from 'lucide-react'
import PropTypes from 'prop-types'
import { useMemo } from 'react'

import { Badge } from '@/components/elements/badge'
import CourseModal from '@/pages/Students/Course/CourseModal'

import InstructorViewContext from './InstructorViewContext'

function InstructorCourseModal({ courseRecord, closeModal, entityId, studentName }) {
  // No lock toggle — instructor view is always read-only. Writes (start,
  // complete, quiz submission) are gated at the boundary in CourseModal /
  // BlockQuiz, so there's nothing the toggle could meaningfully change.
  const banner = (
    <div className="flex items-center justify-between gap-4 bg-amber-100 px-4 py-2 text-sm">
      <span className="font-medium">
        Viewing as <strong>{studentName}</strong>
      </span>
      <Badge variant="warning" size="sm" className="gap-1">
        <Eye className="h-3 w-3" />
        Read-only
      </Badge>
    </div>
  )

  const contextValue = useMemo(() => ({ studentName }), [studentName])

  return (
    <InstructorViewContext.Provider value={contextValue}>
      <CourseModal
        closeModal={closeModal}
        courseRecord={courseRecord}
        entityId={entityId}
        banner={banner}
      />
    </InstructorViewContext.Provider>
  )
}

export default InstructorCourseModal

InstructorCourseModal.propTypes = {
  courseRecord: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  entityId: PropTypes.string.isRequired,
  studentName: PropTypes.string.isRequired,
}
